import { ICourseOfferingLandingPageBreadcrumbQuery } from '../interfaces/course-offering-landing-page-breadcrumb.query.interface';

export class CourseOfferingLandingPageBreadcrumb {
    id: string;
    name: string;
    type: string;

    constructor(query: ICourseOfferingLandingPageBreadcrumbQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.type = query.type;
    }
}
